import { createSearchParams } from 'react-router-dom';
import { pageInfo } from '../../constants/pageInfo/pageInfo.constant';
import { IProduct } from '../../interfaces/Product.interfaces';

export type IProductForGetDetailPageURL = Pick<IProduct, 'id' | 'category'>;

const getBaseProductDetailPageURL = (path: string, additionalPath: string): string => {
  return `${path}/${additionalPath}`;
};

export const getOpenMarketDetailPageURL = (id: string, machineType?: string): string => {
  if (!id) {
    return '';
  }
  const openMarketDetailPagePath = pageInfo.openMarketDetailPage.path;
  const baseUrl = getBaseProductDetailPageURL(openMarketDetailPagePath, id);
  return machineType ? `${baseUrl}?machineType=${machineType}` : baseUrl;
};

export const getGeneralMarketDetailPageURL = (product: IProductForGetDetailPageURL): string => {
  const searchParam = { category: product.category };
  const urlSearchParams = createSearchParams(searchParam).toString();
  const queryParams = urlSearchParams ? `?${urlSearchParams}` : '';
  const productDetailPagePath = pageInfo.productDetailPage.path;
  return getBaseProductDetailPageURL(productDetailPagePath, product.id) + queryParams;
};
